import React from 'react';

const ScrollableWeekWrapper = ({ children }: { children: React.ReactNode }) => {
    return <div className="rbc-row-content-scroll-container">{children}</div>;
};

export default ScrollableWeekWrapper;
